module.exports = __webpack_public_path__ + "static/primary@large-123bd7fb54337b3bd96f243393151dd2.jpg";